import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca74e91c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Accueil", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Courses", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Clients", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Collaborateurs", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cartes", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Paramètres", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://courseur.com/pro/wp-content/uploads/2020/05/Courseur-professionnel-300.png",
    alt: ""
  })
], -1))

import AgencySelector from '@/layouts/components/AgencySelector.vue';
import Balance from '@/layouts/components/Balance.vue';
import Account from '@/layouts/components/Account.vue';

import { onBeforeMount } from 'vue';
import { useAuthStore } from '@/stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

onBeforeMount(async () => {
    await useAuthStore().fetch()
})



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(Account),
      _createVNode(AgencySelector),
      _createVNode(Balance)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("nav", _hoisted_4, [
        _createVNode(_component_router_link, { to: "/home" }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "home",
              key: "home"
            }),
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/transactions" }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "shopping-cart",
              key: "shopping-cart"
            }),
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/clients" }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "user-friends",
              key: "user-friends"
            }),
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/employees" }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "id-badge",
              key: "id-badge"
            }),
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/cards" }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "credit-card",
              key: "credit-card"
            }),
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/settings" }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "cog",
              key: "cog"
            }),
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      _hoisted_11
    ]),
    _createVNode(_component_router_view)
  ]))
}
}

})